import { useEffect } from "react";
import { Container } from "react-bootstrap"

export const DownloadPage = () => {
  useEffect(() => {
    window.location.href =
      "https://ptr.wheelchair.today/protanki-installer.exe";
  }, []);

  return (
    <Container fluid='md' className="mt-2">
    </Container>
  )
}